/*=================================================
	Navigation Icons
/================================================*/
import {
  AdjustmentsHorizontalOutlined,
  AdjustmentsHorizontalSolid,
  ArrowSmallDownOutlined,
  ArrowSmallUpOutlined,
  ArrowsUpDownOutlined,
  ChevronDownOutlined,
  ListViewOutlined,
  ChevronUpOutlined,
  EllipsisVerticalOutlined,
  ChevronLeftOutlined,
  ChevronRightOutlined,
} from '@/assets/svgs/navigation'

import {
  FlagOutlined,
  FlagSolid,
  MinusOutlined,
  XMarkOutlined,
  EditPenOutlined,
  EditPenSolid,
} from '@/assets/svgs/general-tool'

import {
  ArrowDownCircleOutlined,
  ArrowDownCircleSolid,
  CheckCircleOutlined,
  CheckCircleSolid,
  CheckDoubleOutlined,
  CheckHistoryOutlined,
  CheckOutlined,
  ClockOutlined,
  ClockSolid,
  ExclamationCircleOutlined,
  ExclamationCircleSolid,
  InformationCircleOutlined,
  InformationCircleSolid,
  XCircleOutlined,
  XCircleSolid,
} from '@/assets/svgs/status'

import {
  NotificationBellIconOutlined,
  NotificationSettingsOutlined,
  NotificationSettingsSolid,
} from '@/assets/svgs/system'

const iconMap = {
  'x-mark': {
    outlined: XMarkOutlined,
    solid: XMarkOutlined,
  },
  'list-view': {
    outlined: ListViewOutlined,
    solid: ListViewOutlined,
  },
  'adjustments-horizontal': {
    outlined: AdjustmentsHorizontalOutlined,
    solid: AdjustmentsHorizontalSolid,
  },
  check: {
    outlined: CheckOutlined,
    solid: CheckOutlined,
  },
  minus: {
    outlined: MinusOutlined,
    solid: MinusOutlined,
  },
  'notification-settings': {
    outlined: NotificationSettingsOutlined,
    solid: NotificationSettingsSolid,
  },
  notificationBell: {
    outlined: NotificationBellIconOutlined,
  },
  'information-circle': {
    outlined: InformationCircleOutlined,
    solid: InformationCircleSolid,
  },
  'chevron-down': {
    outlined: ChevronDownOutlined,
    solid: ChevronDownOutlined,
  },
  'arrow-small-down': {
    outlined: ArrowSmallDownOutlined,
    solid: ArrowSmallDownOutlined,
  },
  'arrow-small-up': {
    outlined: ArrowSmallUpOutlined,
    solid: ArrowSmallUpOutlined,
  },
  'arrows-up-down': {
    outlined: ArrowsUpDownOutlined,
    solid: ArrowsUpDownOutlined,
  },
  'check-circle': {
    outlined: CheckCircleOutlined,
    solid: CheckCircleSolid,
  },
  'exclamation-circle': {
    outlined: ExclamationCircleOutlined,
    solid: ExclamationCircleSolid,
  },
  clock: {
    outlined: ClockOutlined,
    solid: ClockSolid,
  },
  'check-history': {
    outlined: CheckHistoryOutlined,
    solid: CheckHistoryOutlined,
  },
  'x-circle': {
    outlined: XCircleOutlined,
    solid: XCircleSolid,
  },
  'check-double': {
    outlined: CheckDoubleOutlined,
    solid: CheckDoubleOutlined,
  },
  'arrow-down-circle': {
    outlined: ArrowDownCircleOutlined,
    solid: ArrowDownCircleSolid,
  },
  flag: {
    outlined: FlagOutlined,
    solid: FlagSolid,
  },
  'chevron-up': {
    outlined: ChevronUpOutlined,
    solid: ChevronUpOutlined,
  },
  'ellipsis-vertical': {
    outlined: EllipsisVerticalOutlined,
    solid: EllipsisVerticalOutlined,
  },
  'chevron-left': {
    outlined: ChevronLeftOutlined,
    solid: ChevronLeftOutlined,
  },
  'chevron-right': {
    outlined: ChevronRightOutlined,
    solid: ChevronRightOutlined,
  },
  'edit-pen': {
    outlined: EditPenOutlined,
    solid: EditPenSolid,
  },
}

export default iconMap
